/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useParams } from "react-router-dom";
import { EnvironmentRouteParams, Sla, SupportHours } from "~/models";
import { InlineEditSLA } from "./components/InlineEditSLA";

type Props = {
  refetch: () => void;
  sla: Sla;
  val: string;
  supportHours: SupportHours;
  comm: string;
  serviceId: string;
};

// eslint-disable-next-line sonarjs/cognitive-complexity
export function EditSLA({
  refetch,
  sla,
  val,
  supportHours,
  comm,
  serviceId,
}: Props) {
  const { environmentId } = useParams<EnvironmentRouteParams>();
  const editSLAUrl = `/environments/${environmentId}/services/${serviceId}/slas/${sla?.id}/data`;

  return (
    <>
      <InlineEditSLA
        refetch={refetch}
        sla={sla}
        val={val}
        supportHours={supportHours}
        comm={comm}
        editURL={editSLAUrl}
      />
    </>
  );
}
